import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import PropTypes from 'prop-types'
import { Box } from 'grommet/components/Box';
import { Button } from 'grommet/components/Button';
import { Text } from 'grommet/components/Text';
import data from '../Data.json';
import { EnrollEboxCtrl } from '../Controllers/Ebox/EnrollEboxCtrl';
import { ModifyEboxProfileCtrl } from '../Controllers/Ebox/ModifyEboxProfileCtrl';
import ModalErrorTimeout from './ModalErrorTimeout';
import { loader } from '../Utils/Utility';


class DatiRiepilogo extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }
    constructor(props) {
        super(props);
        this.state = {
            data: data,
            status: '',
            part: [],
            managerList: [],
            isRegistered: sessionStorage.getItem('ebox') === 'SI' ? true : false,
            showTimeoutModal: false,
            loading: false
        }
        //this.saveOrModifyRegistration = this.saveOrModifyRegistration.bind(this);
        this.checked = this.checked.bind(this);

    }

    componentWillMount() {
        if (this.props.values.gestPage === 5) {
            this.getManagerList();
        } else {
            this.getGestore();
        }
    }

    saveAndContinue = (e) => {
        var token = sessionStorage.getItem('token');
        var ids = sessionStorage.getItem('ids');

        if (this.state.isRegistered) {
            const self = this;
            self.setState({loading: true})
            ModifyEboxProfileCtrl(function (data, status) {
                if(status === 200){ 
                    self.setState({loading: false})
                    self.props.history.push({
                        status: status
                    })
                    self.props.nextStep()
                }
            }, function (error) {
                self.setState({
                    status: error
                }, function () {
                    if (this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403) {
                        self.setState({loading: false})
                        self.props.history.push({
                            status: this.state.status
                        })
                    self.props.nextStep()
                    } else if (this.state.status === 401) {
                        this.setState({
                            showTimeoutModal: true
                        })
                        // logout();
                        // this.props.history.push({
                        //     pathname: '/login'
                        // })
                    }
                })
            }, this.props.values, token, ids, this.state.managerList);
        } else {
            const self = this;
            self.setState({loading: true})
            EnrollEboxCtrl(function (data, status) {
                if(status === 200){ 
                    self.setState({loading: false})
                    self.props.history.push({
                        status: status
                    })
                    self.props.nextStep();
                }
            }, function (error) {
                self.setState({
                    status: error
                }, function () {
                    if (this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403) {
                        self.props.history.push({
                            status: this.state.status
                        })
                        self.props.nextStep()
                    } else if (this.state.status === 401) {
                        this.setState({
                            showTimeoutModal: true
                        })
                        // logout();
                        // this.props.history.push({
                        //     pathname: '/login'
                        // })
                    }
                })
            }, this.props.values, token, ids, this.state.managerList);
        }
        e.preventDefault()

    }

    back = (e) => {
        e.preventDefault();
        this.props.prevStep();
    }

    checked(checked) {
        if (checked === 'Y') {
            return 'SI'
        } else {
            return 'NO'
        }
    }

    getManagerList() {
        let obj = {};
        let singlePv = {};
        let listaPV = [];
        let ml= [];
        this.props.location.data.map((el) => {
            obj = {
                codManager: el.codGestore,//selezionato dalla tendina
                description: el.desc,
                user: el.user,
                email: el.email,//da campo di testo
                type: el.tipo,
                typeManager: el.tipoGestore,
                desc: el.desc,
                pointOfSalesList: []
            };

            el.listaPuntiVenditaList.map((pv) =>{
                singlePv = {
                    codPointOfSales: pv.code,
                    name: pv.name,
                    city: pv.city,
                    address: pv.address,
                    codeGest: pv.codeGest,
                    userGest: pv.userGest,
                    emailGest: pv.emailGest
                }
                listaPV.push(singlePv);
                return null;
            });

            obj.pointOfSalesList = listaPV;
            ml.push(obj);
            listaPV=[];

            return null;
        });

        this.setState({
            managerList: ml
        })
    }

    getGestore() {
        let type = null;
        if (this.props.values.selectedType === 'Società' || this.props.values.selectedType === '') {
            type = 'S'
        } else {
            type = 'V'
        }

        let descrizione = "";
        console.log("Arrivati allo script per la descrizione");
        if(!sessionStorage.getItem("desc") || sessionStorage.getItem("desc") === ""){
            console.log("SessionStorage Vuoto");
            if(type === "S"){
                console.log("Type S");
                if(sessionStorage.getItem("codesoc") || sessionStorage.getItem("codesoc")!==""){
                    console.log("codiceSocietà diverso o vuoto");
                    let name = JSON.parse(sessionStorage.getItem('dataWelcome')).name;
                    let address = JSON.parse(sessionStorage.getItem('dataWelcome')).address;
                    let city = JSON.parse(sessionStorage.getItem('dataWelcome')).city;
                    descrizione = `${name} ${address} ${city}`;
                    console.log("Codice società diverso, descrizione impostata: "+ descrizione);
                }else{
                    console.log("codiceSocietà uguale");
                    descrizione = sessionStorage.getItem("insegna");
                    console.log("codiceSocietà uguale, descrizione impostata: "+ descrizione);
                }
            }else{
                console.log("Type non S");
                if(this.props.values.selectedPV === sessionStorage.getItem("insegna")){
                    console.log("codicePV uguale");
                    let name = JSON.parse(sessionStorage.getItem('dataWelcome')).name;
                    let address = JSON.parse(sessionStorage.getItem('dataWelcome')).address;
                    let city = JSON.parse(sessionStorage.getItem('dataWelcome')).city;
                    descrizione = `${name} ${address} ${city}`;
                    console.log("codicePV uguale, descrizione impostata: "+ descrizione);
                }else{
                    console.log("codicePV diverso");
                    try{
                        for (let i=0; i<this.props.values.codes.length; i++){
                            if (this.props.values.codes[i].name === this.props.values.selectedPV){
                                let name = this.props.values.codes[i].name;
                                let address =this.props.values.codes[i].address;
                                let city = this.props.values.codes[i].city;
                                descrizione = name + " " + address + " " + city;
                                console.log("codicePV diverso, descrizione impostata: "+ descrizione);
                            }
                        }
                        console.log("For eseguito con successo");
                    }catch(error){
                        console.log(error.message);
                        descrizione = sessionStorage.getItem("insegna");
                        console.log("Errore durante il for, nuova desc: "+ descrizione);
                    }
                    console.log("codicePV uguale, descrizione impostata: "+ descrizione);
                    if (descrizione === ""){
                        console.log("codicePV uguale, descrizione vuota");
                        descrizione = sessionStorage.getItem("insegna");
                        console.log("codicePV uguale, descrizione vuota, descrizione impostata: "+ descrizione);
                    }
                }
            }
        }else{
            descrizione = sessionStorage.getItem("desc");
            console.log("SessionStorage non Vuoto, descrizione impostata: "+ descrizione);
        }
        if(descrizione === ""){
            console.log("FINE, descrizione vuota, descrizione impostata: "+ descrizione);
            descrizione = sessionStorage.getItem("insegna");
        }

        this.state.managerList.push({
            codManager: this.props.values.codsocieta,//codSocietà
            email: this.props.values.emailGestore,//da campo di testo
            pointOfSalesList: [
                {
                    codPointOfSales: this.props.values.selectedPV !== '' ? this.props.values.selectedPV : ''//selezionato dalla tendina
                }
            ],
            type: type,//values.type,
            typeManager: 'S',//values.typeManager,
            user: this.props.values.selectedUser,
            description: descrizione
        })
    }


    render() {
        const values = this.props.values;

        return (
            <Box>
                {this.state.showTimeoutModal ? <ModalErrorTimeout /> : ''}
                <Box>
                    {values.gestPage === 5 ?
                        this.state.managerList.map((el, index) => (
                            <Box>
                                <Box direction='row' justify='start'>
                                    <Box style={{ padding: '10px 50px 0', width: '300px' }}>
                                        <Box>
                                            <Text className='subtitlehome' style={{ fontFamily: 'Segoe UI Semibold' }}>
                                                <div style={{ textAlign: 'left' }}>Gestore {index + 1} </div> <div style={{ textAlign: 'left' }}>user: {el.user}</div>
                                            </Text>
                                            <Text className='subtitlehome'>Indirizzo Email</Text>
                                            <Text className='subtitlehome'>Codice punto vendita </Text>
                                        </Box>
                                    </Box>
                                    <Box style={{ padding: '10px 10px 0' }}>
                                        <Box>
                                            <Text className='subtitlehome' style={{ fontFamily: 'Segoe UI Semibold' }}>
                                                &nbsp;
                                            </Text>
                                            <Text className='subtitlehome'>{el.email}</Text>
                                            <Text className='subtitlehome'>{el.codManager}</Text>
                                        </Box>
                                    </Box>
                                </Box>

                                <Box direction='column' justify='start' style={{ marginTop: '20px', borderBottom: '1px dashed black' }}>
                                    <Box style={{ padding: '10px 50px 0', width: '300px' }}>
                                        <Text className='subtitlehome' style={{ fontFamily: 'Segoe UI Semibold' }}>
                                            Punti Vendita
                                        </Text>
                                    </Box>
                                    {el.pointOfSalesList.map((pv) => (
                                        <Box direction='row'>
                                            <Box style={{ padding: '10px 50px 0px', width: '300px' }}>
                                                <Box>
                                                    <Text className='subtitlehome'>Codice punto vendita </Text>
                                                    <Text className='subtitlehome'>Insegna</Text>
                                                    <Text className='subtitlehome'>Indirizzo Email</Text>
                                                </Box>
                                            </Box>
                                            <Box style={{ padding: '10px 10px 0px' }}>
                                                <Box>
                                                    <Text className='subtitlehome'>{pv.codPointOfSales}</Text>
                                                    <Text className='subtitlehome'>{pv.name + ' | ' + pv.city + ' | ' + pv.address}</Text>
                                                    <Text className='subtitlehome'>{pv.emailGest}</Text>
                                                </Box>
                                            </Box>
                                        </Box>
                                    ))}
                                </Box>
                            </Box>
                        ))
                        :
                        < Box direction='row' justify='start'>
                            <Box style={{ padding: '50px 50px 0', width: '300px' }}>
                                <Box style={{ paddingBottom: '50px' }}>
                                    <Text className='subtitlehome' style={{ fontFamily: 'Segoe UI Semibold' }}>RESPONSABILE</Text>
                                    <Text className='subtitlehome'>Codice Società</Text>
                                    <Text className='subtitlehome'>Indirizzo e-mail</Text>
                                </Box>
                                <Box>
                                    <Text className='subtitlehome' style={{ fontFamily: 'Segoe UI Semibold' }}>GESTORE 1</Text>
                                    <Text className='subtitlehome'>Indirizzo e-mail</Text>
                                </Box>
                            </Box>

                            <Box style={{ padding: '50px 50px 0', width: '300px' }}>
                                <Box style={{ paddingBottom: '50px' }}>
                                    <Text className='subtitlehome' style={{ fontFamily: 'Segoe UI Semibold' }}>&nbsp;</Text>
                                    <Text className='subtitlehome'>{values.codsocieta}</Text>
                                    <Text className='subtitlehome'>{sessionStorage.getItem('email')}</Text>
                                </Box>
                                <Box>
                                    <Text className='subtitlehome'>{values.selectedType === 'Società' ? values.codsocieta : values.selectedPV}</Text>
                                    <Text className='subtitlehome'>{values.emailGestore}</Text>
                                </Box>
                            </Box>

                        </Box>}
                    <Box style={{ padding: '50px 50px' }}>
                        <Text className='subtitlehome' style={{ fontFamily: 'Segoe UI Semibold' }}>Invio delle comunicazioni via e-mail anche al RESPONSABILE : {this.checked(this.props.values.checked)}</Text>
                    </Box>
                    {this.state.loading ? loader :
                    <Box justify='center' direction='row'>
                        <Button className='btnform' style={{ width: '170px', margin: '0 30px 30px 0' }} onClick={this.back} aria-label="Torna indietro per modificare dati gestore">Indietro</Button>
                        <Button className='btnform' style={{ width: '170px', marginBottom: '30px' }} onClick={this.saveAndContinue} aria-label="Conferma e invia la richiesta di dispute">Conferma</Button>
                    </Box>
                    }
                </Box>
            </Box >

        )
    }
}
export default DatiRiepilogo = withRouter(DatiRiepilogo);